<template>
  <div
    class="flex flex-col max-h-full gap-2 p-2 overflow-y-auto rounded-b-lg bg-eblack-50/70"
  >
    <div
      class="grid grid-cols-2 gap-2"
      v-if="conciergeName || assignedPersonName"
    >
      <div
        class="flex flex-col gap-1"
        data-testid="itinerary-concierge"
        v-if="conciergeName"
      >
        <p class="text-xs text-center text-eblack-500">
          {{ t("itinerary.info.concierge", "Concierge") }}:
        </p>
        <h2 class="text-center text-md font-[500] text-eblack-900">
          {{ conciergeName }}
        </h2>
      </div>
      <div
        class="flex flex-col gap-1"
        data-testid="itinerary-assigned-person"
        v-if="assignedPersonName"
      >
        <p class="text-xs text-center text-eblack-500">
          {{ t("itinerary.info.assigned_person", "Persona asignada") }}:
        </p>
        <h2 class="text-center text-md font-[500] text-eblack-900">
          {{ assignedPersonName }}
        </h2>
      </div>
    </div>
    <div class="grid justify-center gap-2 text-xs grid-col-1 md:grid-cols-2">
      <div
        class="flex flex-col items-center justify-center gap-2 px-4 py-1 border rounded-lg"
      >
        <span>{{ t("itinerary.info.commission_total", "Total de Comisión") }}:</span>
        <span class="font-bold tracking-wider"
          >${{ itinerary.commission_amount ?? 0 }}</span
        >
      </div>

      <div
        class="flex flex-col items-center justify-center gap-2 px-4 py-1 border rounded-lg"
      >
        <span>{{ t("itinerary.info.extra_charges", "Cargos extra") }}:</span>
        <span class="font-bold tracking-wider"
          >${{ itinerary.extra_charge_total ?? 0 }}</span
        >
      </div>

      <div
        class="flex flex-col items-center justify-center gap-2 px-5 py-1 border rounded-lg"
      >
        <span>{{ t("itinerary.info.passengers", "Pasajeros") }}:</span>
        <span class="font-bold tracking-wider">
          {{ itinerary.quantity_of_participants }}
        </span>
      </div>

      <!-- <div class="flex flex-col items-center justify-center gap-2 px-5 py-1 border rounded-lg">
                <span>{{ $t("admin.auto.fecha_inicio") }}</span>
                <span class="font-bold tracking-wider">
                    {{ formatDate(itinerary.start_date) }}
                </span>
            </div>

            <div class="flex flex-col items-center justify-center gap-2 px-5 py-1 border rounded-lg">
                <span>{{ $t("admin.auto.fecha_finalizacion") }}</span>
                <span class="font-bold tracking-wider">
                    {{ formatDate(itinerary.end_date) }}
                </span>
            </div> -->
    </div>
    <div class="flex flex-col gap-1" v-if="itinerary.tags.length > 0">
      <h2 class="text-xs">{{ t("itinerary.info.tags", "Tags") }}:</h2>
      <div class="flex flex-wrap gap-1">
        <span
          class="bg-white border text-xs font-medium me-2 px-2.5 py-0.5 rounded"
          v-for="tag in itinerary.tags"
          v-bind:key="tag"
        >
          {{ tag }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { useItineraryI18n } from "@/domains/itinerary/composables";

export default {
  props: ["itinerary"],
  name: "InfoCardTab",
  setup() {
    const { t } = useItineraryI18n();
    return { t };
  },
  computed: {
    conciergeName() {
      const creator = this.itinerary.creator;
      if (!creator) return "";
      return creator.assigned_person || creator.company_name || "";
    },
    assignedPersonName() {
      const customer = this.itinerary.customer;
      if (!customer) return "";
      return [customer.name, customer.last_name].filter(Boolean).join(" ");
    },
  },
  methods: {
    // formatDate(dateString) {
    //     let date = new Date(dateString);
    //     // Obtener partes de la fecha
    //     let formattedDate = date.toISOString().split("T")[0]; // YYYY-MM-DD
    //     let hours = date.getUTCHours(); // Hora en UTC
    //     let minutes = String(date.getUTCMinutes()).padStart(2, "0"); // Minutos con dos dígitos
    //     let isAM = hours < 12; // AM/PM
    //     if (hours > 12) hours -= 12; // Convertir a formato 12 horas
    //     if (hours === 0) hours = 12; // Ajustar medianoche
    //     // Formatear la hora como 8:00am
    //     let formattedTime = `${hours}:${minutes}${isAM ? "am" : "pm"}`;
    //     return `${formattedDate} ${formattedTime}`;
    // }
  },
};
</script>

<style lang="scss" scoped></style>
